import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AUDIO_FILE_INPUT_ACCEPT } from '../../../constants/file.constants';
import { REMOVE_TEXT, REPLACE_TEXT } from '../../../constants/common-labels.constants';
import DefaultButton from '../default-button/default-button';
import { FileInput } from '../../_events/_manage-event/shared/file-input/file-input';
import { AudioWave } from './audio-wave';

interface IAudioWaveFileProps {
    audioSrc: string;
    audioBlob?: Blob | null;
    audioName: string;
    onChange: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    deleteAudio: () => void;
    disabled?: boolean;
}

const AudioWaveFile = ({
    audioSrc,
    audioBlob,
    audioName,
    onChange,
    deleteAudio,
    disabled = false,
}: IAudioWaveFileProps) => {
    return (
        <div className='audio-wave-file'>
            <input
                className='oe-form-field__control audio-wave-file__name'
                type='text'
                value={audioName}
                readOnly
                disabled
            />
            <AudioWave src={audioSrc} blob={audioBlob} />
            <div className='audio-wave-file__controls'>
                <FileInput
                    className='default-button--slim default-button--options'
                    type='default'
                    title={<FormattedMessage {...REPLACE_TEXT} />}
                    acceptedFileTypes={AUDIO_FILE_INPUT_ACCEPT.join()}
                    onChange={onChange}
                    disabled={disabled}
                />
                <DefaultButton
                    onClick={deleteAudio}
                    text={<FormattedMessage {...REMOVE_TEXT} />}
                    modifier='remove'
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

export {
    AudioWaveFile,
    IAudioWaveFileProps,
};
